import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import cellEditFactory from "react-bootstrap-table2-editor";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory, { PaginationProvider, PaginationListStandalone, PaginationTotalStandalone, SizePerPageDropdownStandalone } from "react-bootstrap-table2-paginator";

import { Col, Row, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faPen, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

import "./tabla.css";

const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
        Mostrando {from} a {to} de {size} Resultados
    </span>
);

class grid extends Component {
    state = {
        selected: []
    }

    calculasizePerPageList = (cantidad) => {
        let lista = [];
        if (cantidad > 10 && cantidad <= 20) {
            lista = [{ text: '10', value: 10 }, { text: 'Todo', value: cantidad }];
            return lista;
        }

        if (cantidad > 20 && cantidad <= 30) {
            lista = [
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: 'Todo', value: cantidad }
            ];
            return lista;
        }

        if (cantidad > 30 && cantidad <= 50) {
            lista = [
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: '30', value: 30 },
                { text: 'Todo', value: cantidad }
            ];
            return lista;
        }

        if (cantidad > 50) {
            lista = [
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: '50', value: 50 },
                { text: '100', value: 100 },
                { text: 'Todo', value: cantidad }
            ];
            return lista;
        }
    }

    handleOnSelect = (row, isSelect) => {
        if (isSelect) {
            this.setState(() => ({
                selected: [row[this.props.keyField]]
            }));
        } else {
            this.setState(() => ({
                selected: []
            }));
        }
        this.props.selectRow.onSelect(row, isSelect);
    }

    render() {
        const { columnas, datos, keyField, modo, rowEvents, rowStyle, rowClasses,
            handleNuevo, handleBorrar, handleActualizar, borrar, paginaActual } = this.props;

        let selectRow = { ...this.props.selectRow };
        selectRow.selected = this.state.selected;
        selectRow.onSelect = this.handleOnSelect;

        const { SearchBar } = Search;
        const nuevo = handleNuevo ? { display: "unset" } : { display: "none" };
        const editar = handleActualizar ? { display: "unset" } : { display: "none" };
        const borrarVisible = handleBorrar ? { display: "unset" } : { display: "none" };
        const _size = datos ? datos.length : 0;
        const _sizePerPageList = this.calculasizePerPageList(_size);

        let optPaginacion = {};

        if (borrar) {
            optPaginacion = {
                custom: true,
                paginationSize: 10,
                pageStartIndex: 1,
                alwaysShowAllBtns: true, // Always show next and previous button
                withFirstAndLast: true, // Hide the going to First and Last page button
                hideSizePerPage: false, // Hide the sizePerPage dropdown always
                hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
                firstPageText: "Primero",
                prePageText: "Anterior",
                nextPageText: "Siguiente",
                lastPageText: "Último",
                nextPageTitle: "Primera Página",
                prePageTitle: "Pre page",
                firstPageTitle: "Siguiente Página",
                lastPageTitle: "Última Página",
                showTotal: true,
                paginationTotalRenderer: customTotal,
                sizePerPageList: _sizePerPageList,
                variation: "dropup",
                dataSize: datos.length,
                page: 1,
                onPageChange: this.props.onPageChange,
                onSizePerPageChange: this.props.onSizePerPageChange
            };
        } else {
            optPaginacion = {
                custom: true,
                paginationSize: 10,
                pageStartIndex: 1,
                alwaysShowAllBtns: true, // Always show next and previous button
                withFirstAndLast: true, // Hide the going to First and Last page button
                hideSizePerPage: false, // Hide the sizePerPage dropdown always
                hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
                firstPageText: "Primero",
                prePageText: "Anterior",
                nextPageText: "Siguiente",
                lastPageText: "Último",
                nextPageTitle: "Primera Página",
                prePageTitle: "Pre page",
                firstPageTitle: "Siguiente Página",
                lastPageTitle: "Última Página",
                showTotal: true,
                paginationTotalRenderer: customTotal,
                sizePerPageList: _sizePerPageList,
                variation: "dropup",
                dataSize: _size,
                onPageChange: this.props.onPageChange,
                onSizePerPageChange: this.props.onSizePerPageChange
            };
        }

        if (paginaActual) {
            optPaginacion.page = paginaActual;
        }

        return (
            <ToolkitProvider
                keyField={keyField}
                data={datos}
                columns={columnas}
                search
            >
                {(props) => (
                    <div>
                        <div className="botones mb-3">
                            <Row className="mt-3">
                                <Col className="text-right">
                                    <div style={nuevo} className="tooltip2">
                                        <span className="tooltiptext2">Nuevo</span>
                                        <Button variant="primary" onClick={handleNuevo}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </Button>
                                    </div>
                                    &nbsp;
                                    <div style={editar} className="tooltip2">
                                        <span className="tooltiptext2">Editar</span>
                                        <Button variant="primary" onClick={handleActualizar}>
                                            <FontAwesomeIcon icon={faPen} />
                                        </Button>
                                    </div>
                                    &nbsp;
                                    <div style={borrarVisible} className="tooltip2">
                                        <span className="tooltiptext2">Eliminar</span>
                                        <Button variant="primary" onClick={handleBorrar}>
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                        </Button>
                                    </div>
                                </Col>
                                <div className="col-3 text-right">
                                    <SearchBar {...props.searchProps} placeholder="Buscar" />
                                </div>
                            </Row>
                        </div>
                        <PaginationProvider pagination={paginationFactory(optPaginacion)}>
                            {({ paginationProps, paginationTableProps }) => (
                                <div>
                                    <div className="table-responsive">
                                        <BootstrapTable
                                            {...props.baseProps}
                                            {...paginationTableProps}
                                            filter={filterFactory()}
                                            cellEdit={cellEditFactory(modo)}
                                            striped={false}
                                            hover={true}
                                            condensed={false}
                                            rowEvents={rowEvents}
                                            selectRow={selectRow}
                                            rowClasses={rowClasses}
                                            noDataIndication={"No hay datos que mostrar"}
                                            insertRow={true}
                                            rowStyle={rowStyle}
                                        />
                                    </div>
                                    <SizePerPageDropdownStandalone {...paginationProps} />

                                    <PaginationTotalStandalone {...paginationProps} />
                                    <PaginationListStandalone {...paginationProps} />
                                </div>
                            )}
                        </PaginationProvider>
                    </div>
                )}
            </ToolkitProvider>
        );
    }
}

export default grid;